import createIcon from '../../createIcon';

/**
 * @component @name OnDeviceTraining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTZIMTFWMTdIMTNWMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgMTFDMTAuOSAxMSAxMCAxMS45IDEwIDEzQzEwIDEzLjc0IDEwLjQgMTQuMzggMTEgMTQuNzJWMTUuNUgxM1YxNC43MkMxMy42IDE0LjM3IDE0IDEzLjc0IDE0IDEzQzE0IDExLjkgMTMuMSAxMSAxMiAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOCAxLjAxTDYgMUM0LjkgMSA0IDEuOSA0IDNWMjFDNCAyMi4xIDQuOSAyMyA2IDIzSDE4QzE5LjEgMjMgMjAgMjIuMSAyMCAyMVYzQzIwIDEuOSAxOS4xIDEuMDEgMTggMS4wMVpNMTggMThINlY2SDE4VjE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjAxIDE1Ljk1QzE2LjYzIDE1LjEyIDE3IDE0LjExIDE3IDEzQzE3IDExLjg5IDE2LjYzIDEwLjg4IDE2LjAxIDEwLjA1TDE0Ljk0IDExLjEyQzE1LjI5IDExLjY2IDE1LjUgMTIuMzEgMTUuNSAxM0MxNS41IDEzLjY5IDE1LjI5IDE0LjM0IDE0Ljk0IDE0Ljg4TDE2LjAxIDE1Ljk1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkuMDYgMTQuODhDOC43MSAxNC4zNCA4LjUgMTMuNjkgOC41IDEzQzguNSAxMS4wNyAxMC4wNyA5LjUgMTIgOS41VjEwLjc1TDE0LjI1IDguNzVMMTIgNi43NVY4QzkuMjQgOCA3IDEwLjI0IDcgMTNDNyAxNC4xMSA3LjM3IDE1LjEyIDcuOTkgMTUuOTVMOS4wNiAxNC44OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OnDeviceTraining = createIcon('OnDeviceTraining', [
  ['path', { d: 'M13 16H11V17H13V16Z', key: '1aeqbg' }],
  [
    'path',
    {
      d: 'M12 11C10.9 11 10 11.9 10 13C10 13.74 10.4 14.38 11 14.72V15.5H13V14.72C13.6 14.37 14 13.74 14 13C14 11.9 13.1 11 12 11Z',
      key: 'lhjs7',
    },
  ],
  [
    'path',
    {
      d: 'M18 1.01L6 1C4.9 1 4 1.9 4 3V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V3C20 1.9 19.1 1.01 18 1.01ZM18 18H6V6H18V18Z',
      key: 'pjanz4',
    },
  ],
  [
    'path',
    {
      d: 'M16.01 15.95C16.63 15.12 17 14.11 17 13C17 11.89 16.63 10.88 16.01 10.05L14.94 11.12C15.29 11.66 15.5 12.31 15.5 13C15.5 13.69 15.29 14.34 14.94 14.88L16.01 15.95Z',
      key: '14y74y',
    },
  ],
  [
    'path',
    {
      d: 'M9.06 14.88C8.71 14.34 8.5 13.69 8.5 13C8.5 11.07 10.07 9.5 12 9.5V10.75L14.25 8.75L12 6.75V8C9.24 8 7 10.24 7 13C7 14.11 7.37 15.12 7.99 15.95L9.06 14.88Z',
      key: '51638i',
    },
  ],
]);

export default OnDeviceTraining;
